import { useState } from "react";
import type { UseFormSetValue } from "react-hook-form";
import type { IncomeSheetFormModel } from "web_myplann/Finances/Forms/useIncomeSheetForm";
import type {
	IncomeFormEntry,
	IncomeFormModel,
} from "web_myplann/Finances/Forms/useIncomeV2Form";
import { useListItemEditor } from "web_myplann/Shared/Hooks/useListItemEditor";

type Params = {
	incomes: IncomeFormEntry[];
	incomeAppend: (income: IncomeFormEntry) => void;
	setValue: UseFormSetValue<IncomeFormModel>;
};

export const useIncomeEditor = ({
	incomes,
	incomeAppend,
	setValue,
}: Params) => {
	const [open, setOpen] = useState(false);
	const { editingIndex, isEditing, initialValues, startEdit, stopEdit } =
		useListItemEditor(incomes, (income) => ({
			name: income.name,
			amount: income.amount,
		}));

	const openAdd = () => {
		stopEdit();
		setOpen(true);
	};

	const openEdit = (index: number) => {
		startEdit(index);
		setOpen(true);
	};

	const close = () => {
		setOpen(false);
		stopEdit();
	};

	const submit = ({ name, amount }: IncomeSheetFormModel) => {
		if (editingIndex === null) {
			incomeAppend({ id: null, name, amount });
		} else {
			setValue(`entries.${editingIndex}.name`, name);
			setValue(`entries.${editingIndex}.amount`, amount);
		}
		close();
	};

	return {
		open,
		isEditing,
		initialValues,
		openAdd,
		openEdit,
		close,
		submit,
	};
};
